module.exports = "pegasus/assets/themelp1/simple/107.png";